import { Box, Skeleton, Typography, useTheme } from '@mui/material';
import zeplinColor from 'theme/Color';

const formatNumber = (num: number): string => {
  if (num >= 1_000_000_000) {
    return `${(num / 1_000_000_000).toFixed(2)}B`;
  } else if (num >= 1_000_000) {
    return `${(num / 1_000_000).toFixed(2)}M`;
  } else if (num >= 1_000) {
    return `${(num / 1_000).toFixed(2)}k`;
  }
  return num.toString();
};
const Card = ({ val, loading }: { val: any; loading: boolean }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        borderRadius: '14px',
        border: `1px solid ${zeplinColor.Neutral5}`,
        padding: '16px',
        display: 'flex',
        gap: '12px',
      }}
    >
      <Box
        sx={{
          width: '60px',
          height: '60px',
          borderRadius: '8px',
          backgroundColor: zeplinColor.Neutral3,
        }}
      >
        {loading ? (
          <Skeleton
            variant='rounded'
            width={60}
            height={60}
            sx={{ backgroundColor: zeplinColor.Neutral4 }}
          />
        ) : (
          <img
            src={val?.logo}
            width='60px'
            height='60px'
            alt='industry'
            style={{ objectFit: 'contain' }}
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = '/assets/zoominfo-fallback.svg';
            }}
          />
        )}
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {loading ? (
          <Skeleton
            variant='text'
            sx={{
              fontSize: theme.typography.body2,
              width: '5rem',
              backgroundColor: zeplinColor.Neutral4,
            }}
          />
        ) : (
          <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
            {val?.name}
          </Typography>
        )}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <img src='/assets/zoominfo-fallback.svg' width='20px' height='20px' alt='industry' />
            {loading ? (
              <Skeleton
                variant='text'
                sx={{
                  fontSize: theme.typography.body2,
                  width: '5rem',
                  backgroundColor: zeplinColor.Neutral4,
                }}
              />
            ) : (
              <Typography variant='responsiveBody3'>{val?.industries?.join(',')}</Typography>
            )}
          </Box>
          <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <img src='/assets/dollar-circle.svg' width='20px' height='20px' alt='industry' />
            {loading ? (
              <Skeleton
                variant='text'
                sx={{
                  fontSize: theme.typography.body2,
                  width: '5rem',
                  backgroundColor: zeplinColor.Neutral4,
                }}
              />
            ) : (
              <Typography variant='responsiveBody3'>
                ${formatNumber(val?.revenue)} Revenue
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Card;
